<div class="verification-container">
  <div (click)="closeModal()" class="icon-close">
    <i class="icon-X"></i>
  </div>
  <div class="verification-img">
    <img alt="Verification email" src="assets/images/email-verification.svg">
  </div>
  <h3 class="verification-title text-llg">{{ 'Verify it’s you'|translate }}</h3>
  <p class="description verification-text">{{ 'We sent verification code to'|translate }} <span
    class="text--semi-bold">{{ data.email }}</span>.
    {{ 'Please check your inbox and enter the code below'|translate }}.</p>
  <app-input
    [formControl]="verificationCode"
    [max]="6"
    [pastePattern]="PASTE_CODE_REGEX"
    [pattern]="VALIDATION_CODE_REGEX"
    [placeholder]="'Enter 6-digits code'|translate"
    [title]="'6-digits code'|translate"
    type="text"
  ></app-input>
  <div class="verify-btn">
    <button
      type="submit"
      aria-label="Verify code"
      (click)="verify()"
      [disabled]="verificationCode.invalid"
      [mat-dialog-close]="verificationCode.value"
      mat-button
    >{{ 'Verify code'|translate }}
    </button>
  </div>
  <div class="try-again-container">
    <span class="description">{{ 'Didn’t receive an email'|translate }}?</span>
    <span (click)="tryAgain()" [class.try-again-disabled]="tryAgainDisabled"
          class="try-again-btn">{{ 'Try again'|translate }}</span>
    @if (tryAgainDisabled) {
      <span class="description">{{ displayTimer }}</span>
    }
  </div>

</div>
